import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { FormControl, Input, InputAdornment, InputLabel } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

import { useDebounce } from "../../../shared/hooks/use-debounce";

export function OrdersSearchFilter() {
	const [searchParams, setSearchParams] = useSearchParams();
	const [inputValue, setInputValue] = useState(
		searchParams.get("search") ?? "",
	);
	const debouncedValue = useDebounce(inputValue);
	const isFirstRender = useRef(true);

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;
			return;
		}

		setSearchParams(
			(prev) => {
				const next = new URLSearchParams(prev);
				if (debouncedValue) {
					next.set("search", debouncedValue);
				} else {
					next.delete("search");
				}
				next.delete("page");
				return next;
			},
			{ replace: true },
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [debouncedValue]);

	return (
		<FormControl variant="standard" sx={{ width: { xs: "100%", sm: 400 } }}>
			<InputLabel htmlFor="orders-search">Pesquisar</InputLabel>
			<Input
				id="orders-search"
				placeholder="Nº pedido, cliente ou placa"
				value={inputValue}
				onChange={(e) => setInputValue(e.target.value)}
				startAdornment={
					<InputAdornment position="start">
						<SearchIcon fontSize="small" />
					</InputAdornment>
				}
			/>
		</FormControl>
	);
}
